<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
    <v-toolbar dark :color="options.color" dense v-if="title">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card tile>
      <v-card-text
        v-show="!!message"
        class="confirmation-text"
      >
        <v-layout wrap>
          <v-flex xs12 class="mt-2">
            <span v-html="message"></span>
          </v-flex>
          <v-flex
            v-if="options.enableNotes"
            xs12
          >
            <v-textarea
              v-model="notes"
              v-validate="'regex:^.*$'"
              :error-messages="errors.collect('notes')"
              data-vv-name="notes"
              auto-grow
              label="Notes"
              rows="2"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">{{ options.noLabel }}</v-btn>
        <v-btn :color="options.color" text @click="agree">{{ options.yesLabel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: 'confirmValidator',
  },
  mounted() {
    this.$validator.localize('en', this.validationDictionary);
  },
  data() {
    return {
      notes: '',
      dialog: false,
      options: {
        color: 'primary',
        width: 290,
        yesLabel: 'Yes',
        noLabel: 'No',
        enableNotes: false,
        isNotesRequired: false,
      },
    };
  },
  computed: {
    validationDictionary() {
      const validationDictionary = {
        attributes: {
          notes: this.$t('fields.Notes'),
        },
      };

      return validationDictionary;
    },
  },
  methods: {
    agree() {
      if (this.options.isNotesRequired && this.notes === '') {
        this.$validator.errors.add({
          scope: null, field: 'notes', msg: this.$t('validation.notesRequired'),
        });
      } else {
        this.dialog = false;
        this.$emit('close', true, this.notes);
      }
    },
    cancel() {
      this.dialog = false;
      this.errors.clear();
      this.notes = '';
      this.$emit('close', false);
    },
    open() {
      this.dialog = true;
    },
  },
  created() {
    Object.assign(this.options, this.params);
  },
  props: {
    message: String,
    title: String,
    params: Object,
  },
};
</script>

<style lang="scss">
  .confirmation-text {
    word-break: break-word;
  }
</style>
